import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import BagianGoogle from "../components/auth/TombolGoogle";
import { jalurChat } from "./chatKonteks";
import { IkonTutup } from "./IkonChat";

// Papan "HP · Belum masuk akun". Sesudah masuk kembali ke ruang chat dengan konteks yang sama.
export default function LembarMasukChat({ konteks, onTutup }) {
  const tujuan = jalurChat(konteks);
  const tutup = useRef(null);
  useEffect(() => {
    if (tutup.current) tutup.current.focus();
    const esc = (e) => { if (e.key === "Escape") onTutup(); };
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onTutup]);
  const kalimat = konteks && konteks.pesanan_id ? "Sesudah masuk, Anda kembali ke chat pesanan ini."
    : konteks && konteks.produk_id ? "Sesudah masuk, Anda kembali ke chat produk ini." : "Sesudah masuk, Anda kembali ke chat.";
  return (
    <div className="cht-lapis" onClick={(e) => { if (e.target === e.currentTarget) onTutup(); }} data-testid="chat-lembar-masuk">
      <section className="cht-lembar" role="dialog" aria-modal="true" aria-label="Masuk untuk chat">
        <div className="cht-lembar__pegangan"><span /></div>
        <div className="cht-lembar__kepala">
          <b>Masuk untuk chat</b>
          <button type="button" ref={tutup} aria-label="Tutup" onClick={onTutup} data-testid="chat-lembar-tutup"><IkonTutup /></button>
        </div>
        <p>Masuk atau daftar agar kami bisa membalas dan Anda bisa melihat chat ini lagi nanti.</p>
        <BagianGoogle dari={tujuan} hp />
        <div className="cht-lembar__dua">
          <Link to="/login" state={{ from: tujuan }} className="is-utama" data-testid="chat-lembar-masuk-tombol" onClick={onTutup}>Masuk</Link>
          <Link to="/register" state={{ from: tujuan }} className="is-garis" data-testid="chat-lembar-daftar" onClick={onTutup}>Daftar</Link>
        </div>
        <span className="cht-lembar__catatan">{kalimat}</span>
      </section>
    </div>
  );
}
